<template>
  <div class="Source" :class="{'active': source.active, 'loading': !source.hasLoadedArticles}" @click="toggleActive">

    {{source.name}}

  </div>
</template>

<script>

//import Article from '@/components/Article.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Source',
  components: {
    //Article
  },
  data: function () {
    return {
      //name: "name"
    }
  },
  props: {
    source: Object
  },
  computed: {
    ...mapGetters('articles',[
      'articlesBySourceId',
    ]),
  },
  methods: {
    toggleActive: function () {
      this.$store.commit('sources/setSourceActive',{source: this.source, active: !this.source.active});
    }
  },
  mounted: function () {
    this.$store.dispatch('sources/setRSS',{source: this.source});
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.Source{
  font-family: var(--font-header);
  display: inline-flex;
  background: white;
  border: var(--border);
  padding: 5px 15px 5px 15px;
  cursor: pointer;
}

.active {
  background: var(--color);
  color: white;
}

.active.loading{
  color: black;
  animation-name: loading;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
}

@keyframes loading {
  from {background: white;}
  to {background: lightgray;}
}

</style>
